var _rect, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _path, _path2, _path3, _rect7, _path4, _rect8, _path5, _path6, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectCardIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 15.2,
    y: 31.2,
    width: 9.6,
    height: 5.6,
    fill: "#7A9FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.800049,
    width: 40,
    height: 30.4,
    rx: 4,
    fill: "#7A9FFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 10.4001,
    y: 36.8,
    width: 19.2,
    height: 2.4,
    rx: 1.2,
    fill: "#7A9FFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.5999,
    y: 28,
    width: 4.8,
    height: 1.6,
    rx: 0.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 38,
    height: 25
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6001,
    y: 2.40002,
    width: 36.8,
    height: 24,
    rx: 3,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_624)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.6001,
    y: 2.40002,
    width: 36.8,
    height: 24,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6001,
    y: 2.40002,
    width: 36.8,
    height: 3.2,
    fill: "#2E3769"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 4.8,
    cy: 4.00001,
    r: 0.8,
    fill: "#4A67FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.1999,
    cy: 4.00001,
    r: 0.8,
    fill: "#4A67FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9.60005,
    cy: 4.00001,
    r: 0.8,
    fill: "#4A67FF"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4,
    y: 8,
    width: 14.4,
    height: 14.4,
    rx: 4,
    fill: "#4A67FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 11.2H34.4001",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 15.2001H34.4001",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 19.2H28.7112",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 14,
    width: 24.48,
    height: 36,
    rx: 4,
    fill: "#7A9FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.68 16.52C32.68 15.9235 32.1965 15.44 31.6 15.44H29.44C27.6506 15.44 26.2 16.8906 26.2 18.68V44.56C26.2 46.7691 27.9908 48.56 30.2 48.56H43.8C46.0091 48.56 47.8 46.7691 47.8 44.56V18.68C47.8 16.8906 46.3494 15.44 44.56 15.44H42.4C41.8035 15.44 41.32 15.9235 41.32 16.52C41.32 17.1165 40.8365 17.6 40.24 17.6H33.76C33.1635 17.6 32.68 17.1165 32.68 16.52Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 27.6399,
    y: 21.2,
    width: 7.2,
    height: 7.2,
    rx: 2,
    fill: "#4A67FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 23.36H44.92",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 26.24H44.92",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 27.6399,
    y: 29.84,
    width: 18.72,
    height: 7.2,
    rx: 2,
    fill: "#4A67FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 27.6399,
    y: 38.48,
    width: 18.72,
    height: 7.2,
    rx: 2,
    fill: "#4A67FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCardIcon1);
export default __webpack_public_path__ + "static/media/project-card-icon-1.ca69939c5b4facf734149ef4d246f348.svg";
export { ForwardRef as ReactComponent };